module.exports = __webpack_public_path__ + "static/006720-c527d4b8950e658f442d26ef59eed899.jpg";